import React, { useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import BasicLayout from 'components/atoms/Modal/Basic.Layout';
import { isACtiveDementiaBoxModal } from 'modules/actions/dementia';
import ReactHtmlParser from 'react-html-parser';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import { chatList } from 'modules/actions/chat';

const Dementia = () => {
  const dispatch = useDispatch();
  const dementiaList = useSelector(state => state.dementia.dementiaboxModal.dementiaList);
  const { items, id } = dementiaList.dementiaList;
  let sum = 0;

  const subMit = () => {
    items.forEach((tempItem, idx) => {
      /* console.log(document.querySelector(`input[name="${'checkbox'+idx}"]:checked`)); */
      if (document.querySelector(`input[name="${'checkbox' + idx}"]:checked`) !== null) {
        sum += parseInt(document.querySelector(`input[name="${'checkbox' + idx}"]:checked`).value, 10);
        console.log(document.querySelector(`input[name="${'checkbox' + idx}"]:checked`).value);
      }
    });
    if (sum > 6) {
      const paramSet = {
        inType: 'query',
        inStr: '6점 이상입니다',
      };
      dispatch(chatList(paramSet));
    } else {
      const paramSet = {
        inType: 'query',
        inStr: '5점 이하입니다',
      };
      dispatch(chatList(paramSet));
    }
    dispatch(
      isACtiveDementiaBoxModal({
        dementiaboxModal: {
          dementiaStatus: false,
          dementiaList: { dementiaList },
        },
      })
    );
  };

  const constentSet = () => {
    return (
      <div className="_dementia_div">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell style={{padding:'10px'}}>
                <div className="_dementia_div_area">
                  <div className="_dementia_div_title">채점기준</div>
                  <div className="_dementia_div_num">
                    ·아니다 (0점)
                    <br />
                    ·가끔 그렇다(1점)
                    <br />
                    ·자주 그렇다(2점)
                  </div>
                </div>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {items !== undefined &&
              items.map((tempItem, idx) => {
                return (
                  <TableRow>
                    <div className="_dementia_list">
                      <TableCell style={{borderBottom:'none'}}>
                        <div className="_dementia_name">
                        <span>{idx+1}</span>{ReactHtmlParser(tempItem?.text?.desc || '')}
                        </div>
                        <br />
                        <div className="_dementia_checkbox">
                          <input type="radio" id={tempItem + '0_' + idx} name={'checkbox' + idx} value={0} key={tempItem + '0_' + idx} />
                          아니다 &nbsp;&nbsp;
                          <input type="radio" id={tempItem + '1_' + idx} name={'checkbox' + idx} value={1} key={tempItem + '1_' + idx} />
                          가끔 그렇다 &nbsp;&nbsp;
                          <input type="radio" id={tempItem + '2_' + idx} name={'checkbox' + idx} value={2} key={tempItem + '2_' + idx} />
                          자주 그렇다
                        </div>
                      </TableCell>
                    </div>
                    <br />
                  </TableRow>
                );
              })}
          </TableBody>
          <div className="_dementia_submit" onClick={() => subMit()}>
            <div className="_button">제출 하기</div>
          </div>
        </Table>
      </div>
    );
  };

  return (
    <BasicLayout
      label="자가진단테스트"
      value="자가진단테스트"
      labelIcon="ri-thumb-up-line"
      viewStatus=""
      styleDef={{ width:'350px', height: '550px', zIndex: '15', padding: '12px', overflowY: 'scroll' }}
      onClickEvt={() =>
        dispatch(
          isACtiveDementiaBoxModal({
            dementiaboxModal: {
              dementiaStatus: false,
              dementiaList: { dementiaList },
            },
          })
        )
      }
      error={null}
      contentSet={constentSet}
    />
  );
};

export default Dementia;
